import { Modal, baseVariables, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

const { mediaQuery, font, color } = baseVariables;

export const StyledInventoryCheckModal = styled(Modal)`
  overflow: auto;
  height: 100%;
  .modal-body {
    &.inventory-modal-body {
      font-weight: ${font.fontWeightMedium};
    }
    padding: ${toRem(32)} 0;
    ol {
      padding-left: ${toRem(32)};
      margin-bottom: ${toRem(25)};
    }
    .notes {
      color: ${color.neutral40};
      font-size: ${toRem(13)};
      margin: 0 ${toRem(8)};
    }
    @media ${mediaQuery.md} {
      overflow: visible;
    }
  }
  .modal-footer {
    &.inventory-modal-footer {
      border-top: ${toRem(1)} solid ${color.neutral30};
      background-color: ${color.base20};
    }
  }
`;
